export enum LoanTransactionsFilterBy {
	YEAR = 'Year',
	STATUS = 'Status',
	TYPE = 'Type',
}
